import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'asset',
    loadChildren: () => import('./pages/asset/asset.module').then(m => m.AssetPageModule)
  },
  {
    path: '',
    loadChildren: () => import('./pages/asset-list/asset-list.module').then(m => m.AssetListModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
